// Suffix "KEY" is added to avoid JavaScript collisions
export const ARROW_UP_KEY = 38
export const ARROW_DOWN_KEY = 40
export const C_KEY = 67
export const R_KEY = 82
export const TAB_KEY = 9
